module.exports = __webpack_public_path__ + "static/media/bg_login_wide_commerz.072377d2.png";